/* Snatched — reveals, nav, parallax. Cart logic stays in theme.js. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* hero panels in on load */
  var pans = document.querySelectorAll('.split .pan');
  if (pans.length) {
    if (reduce) { Array.prototype.forEach.call(pans, function (p) { p.classList.add('in'); }); }
    else {
      requestAnimationFrame(function () {
        setTimeout(function () { Array.prototype.forEach.call(pans, function (p) { p.classList.add('in'); }); }, 60);
      });
    }
  }

  /* tag what reveals */
  var RV = '.cat, .card .ph, .look-g figure, .night figure, .pd-main';
  var FADE = '.sec-h, .shop-head .filters, .card .meta, .card .sub, .night-in>div, .drop, .sign form, .sign>div, .drops-head, .look-head, .pd-info>*';
  document.querySelectorAll(RV).forEach(function (e) { e.classList.add('rv'); });
  document.querySelectorAll(FADE).forEach(function (e) { e.classList.add('fade'); });

  if (reduce || !('IntersectionObserver' in window)) {
    document.querySelectorAll('.rv,.fade').forEach(function (e) { e.classList.add('in'); });
  } else {
    /* stagger grid children */
    function stagger(sel, step) {
      document.querySelectorAll(sel).forEach(function (parent) {
        Array.prototype.forEach.call(parent.children, function (child, i) {
          var targets = [];
          if (child.classList.contains('rv') || child.classList.contains('fade')) targets.push(child);
          child.querySelectorAll('.rv,.fade').forEach(function (t) { targets.push(t); });
          targets.forEach(function (t) { t.style.transitionDelay = (i * step) + 's'; });
        });
      });
    }
    stagger('.grid', 0.07); stagger('.look-g', 0.07); stagger('.cats', 0.09);

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    document.querySelectorAll('.rv,.fade').forEach(function (e) { io.observe(e); });

    /* safety net: nothing may stay invisible */
    var sweep = function () {
      document.querySelectorAll('.rv:not(.in),.fade:not(.in)').forEach(function (e) {
        if (e.getBoundingClientRect().top < window.innerHeight * 1.1) e.classList.add('in');
      });
    };
    setTimeout(sweep, 1500);
    window.addEventListener('load', function () { setTimeout(sweep, 400); });
  }

  /* mobile nav */
  var burger = document.querySelector('.burger');
  if (burger) {
    burger.addEventListener('click', function () {
      var m = document.querySelector('.nav menu');
      if (m) m.classList.toggle('open');
    });
    var m = document.querySelector('.nav menu');
    if (m) m.addEventListener('click', function (e) { if (e.target.closest('a')) m.classList.remove('open'); });
  }

  /* esc closes the cart */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (document.querySelector('.cart-drawer.open') && typeof window.toggleCartDrawer === 'function') window.toggleCartDrawer();
  });

  /* one deliberate parallax: studio band photo */
  if (!reduce) {
    var band = document.querySelector('.night figure');
    if (band) {
      var bimg = band.querySelector('img');
      if (bimg) {
        bimg.style.height = '116%';
        bimg.style.position = 'relative';
        var tick = false;
        var run = function () {
          if (tick) return; tick = true;
          requestAnimationFrame(function () {
            tick = false;
            var r = band.getBoundingClientRect();
            var p = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
            p = Math.max(-1, Math.min(1, p));
            bimg.style.transform = 'translateY(' + (p * -6) + '%)';
          });
        };
        window.addEventListener('scroll', run, { passive: true });
        window.addEventListener('resize', run, { passive: true });
        run();
      }
    }
  }

  /* product gallery thumbs */
  var mainImg = document.querySelector('.pd-main img');
  if (mainImg) {
    document.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        document.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        mainImg.src = t.getAttribute('data-thumb');
      });
    });
  }
})();
